<style scoped>
    .wrapper {
        display: flex;
    }

    .input-container {
        flex: 0 0 auto;
        margin-right: 0.6ch;
    }

    .content {
        flex: 1 1 0;
    }
</style>

<template>
    <label class="wrapper">
        <div class="input-container">
            <input :type="type" :checked="checked" :disabled="disabled" @change="handleChange" />
        </div>

        <div class="content">
            <slot />
        </div>
    </label>
</template>

<script>
    export default {
        model: {
            prop: 'modelValue',
        },

        props: ['type', 'modelValue', 'value', 'disabled'],

        computed: {
            checked() {
                if (Array.isArray(this.modelValue)) {
                    return this.modelValue.includes(this.value);
                } else {
                    return this.value === this.modelValue;
                }
            },
        },

        methods: {
            handleChange(event) {
                let value = event.target.checked;

                if ('value' in this.$props) {
                    if (Array.isArray(this.modelValue)) {
                        value = [...this.modelValue];
                        const index = this.modelValue.indexOf(this.value);
                        if (event.target.checked) {
                            if (index === -1) {
                                value.push(this.value);
                            }
                        } else {
                            if (index !== -1) {
                                value.splice(index, 1);
                            }
                        }
                    } else {
                        if (event.target.checked) {
                            value = this.value;
                        } else {
                            value = null;
                        }
                    }
                }

                this.$emit('input', value);
            },
        },
    };
</script>
